<template>
	<div class="formula-selector-container flex-column">
		<div class="header">
			<div class="item-title primary-font-color">{{ title }}</div>
			<div v-if="isChooseFirstItem" class="desc">
				What do you want to do if there's more than one item in this collection?
				<a
					class="link-style"
					target="_blank"
					href="https://docs.ply.io/article/iqve8s3x6z-working-with-item-and-table-data#working_with_items_and_tables
"
					>Learn more</a
				>
			</div>
		</div>
		<FormulaSelector :allowKeyboardNavigation="allowKeyboardNavigation" :autoFocus="autoFocus" v-on="$listeners" :formulas="formulas" />
	</div>
</template>

<script>
import FormulaSelector from './Formulas/FormulaSelector';
import { FORMULAS_KEYS } from '../common/RichTextBox/FormulaChip/formulas.const';
export default {
	name: 'FormulaSelectorContainer',
	components: { FormulaSelector },
	props: {
		formulas: { type: Array },
		allowKeyboardNavigation: { type: Boolean },
		autoFocus: { type: Boolean },
	},
	computed: {
		isChooseFirstItem() {
			return this.formulas.length === 1 && this.formulas[0] === FORMULAS_KEYS.VALUE_IN_FIRST_ELEMENT;
		},
		title() {
			return this.isChooseFirstItem ? 'Extract item from collection' : 'Choose formula';
		},
	},
};
</script>

<style lang="scss" scoped>
.formula-selector-container {
	--desc-color: #a5a5a5;

	.header {
		padding: 0 0px 4px 6px;

		.item-title {
			font-size: 12px;
			font-weight: bold;
		}
		.desc {
			font-size: 10px;
			color: var(--desc-color);
			.link-style {
				color: var(--desc-color) !important;
			}
		}
	}

	::v-deep(.list-item-start) {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-direction: row !important;
	}
}
</style>
